const REASON_MAP = {
  medical: 'MEDICAL',
  personal: 'PERSONAL',
  'non-responsive': 'NON_RESPONSIVE',
  non_responsive: 'NON_RESPONSIVE',
}

const HEADER_ALIASES = {
  'patient id': 'patientId',
  patient_id: 'patientId',
  patientid: 'patientId',
  reason: 'reason',
  mobility: 'mobility',
  sleep: 'sleep',
  'tremor & dyskinesia': 'tremorDyskinesia',
  'tremor and dyskinesia': 'tremorDyskinesia',
  tremor_dyskinesia: 'tremorDyskinesia',
  detail: 'detail',
  details: 'detail',
}

const REQUIRED_FIELDS = ['patientId', 'reason']

/**
 * Parse a CSV row respecting quoted fields with commas and escaped quotes.
 * @param {string} line - A single CSV line
 * @returns {string[]} Array of field values
 */
const parseCsvLine = (line) => {
  const fields = []
  let current = ''
  let inQuotes = false

  for (let i = 0; i < line.length; i++) {
    const ch = line[i]
    if (inQuotes) {
      if (ch === '"') {
        if (i + 1 < line.length && line[i + 1] === '"') {
          current += '"'
          i++
        } else {
          inQuotes = false
        }
      } else {
        current += ch
      }
    } else if (ch === '"') {
      inQuotes = true
    } else if (ch === ',') {
      fields.push(current.trim())
      current = ''
    } else {
      current += ch
    }
  }
  fields.push(current.trim())
  return fields
}

const resolveHeaders = (headerLine) => {
  const rawHeaders = parseCsvLine(headerLine)
  const columnMap = {}

  rawHeaders.forEach((raw, index) => {
    const normalized = raw.toLowerCase().trim()
    const field = HEADER_ALIASES[normalized]
    if (field) columnMap[field] = index
  })

  return columnMap
}

const parseExemptionCsv = (text) => {
  const lines = text.split(/\r?\n/).filter((l) => l.trim())
  if (lines.length < 2) {
    return {
      rows: [],
      errors: ['CSV must have a header row and at least one data row.'],
    }
  }

  const columnMap = resolveHeaders(lines[0])

  const missingHeaders = REQUIRED_FIELDS.filter(
    (field) => !(field in columnMap),
  )
  if (missingHeaders.length > 0) {
    return {
      rows: [],
      errors: [
        `Missing required columns: ${missingHeaders.join(
          ', ',
        )}. Found headers: ${parseCsvLine(lines[0]).join(', ')}`,
      ],
    }
  }

  const rows = []
  const errors = []

  const col = (fields, field) =>
    field in columnMap ? fields[columnMap[field]] || '' : ''

  for (let i = 1; i < lines.length; i++) {
    const fields = parseCsvLine(lines[i])

    const patientId = col(fields, 'patientId')
    if (!patientId) {
      errors.push(`Row ${i + 1}: missing Patient ID`)
      continue
    }

    const reasonRaw = col(fields, 'reason')
    const reason = REASON_MAP[reasonRaw.toLowerCase()]
    if (!reason) {
      errors.push(
        `Row ${
          i + 1
        }: unknown reason "${reasonRaw}" (expected Medical, Personal, or Non-Responsive)`,
      )
      continue
    }

    const categories = []
    if (col(fields, 'mobility').toUpperCase() === 'TRUE')
      categories.push('MOBILITY')
    if (col(fields, 'sleep').toUpperCase() === 'TRUE') categories.push('SLEEP')
    if (col(fields, 'tremorDyskinesia').toUpperCase() === 'TRUE')
      categories.push('TREMOR_DYSKINESIA')

    if (categories.length === 0) {
      errors.push(`Row ${i + 1}: at least one category must be TRUE`)
      continue
    }

    const detail = col(fields, 'detail')

    rows.push({
      patientId,
      reason,
      categories,
      detail: detail || null,
    })
  }

  return { rows, errors }
}

export default parseExemptionCsv
